import { SideNav, SideNavContent } from "components";
import {
  HeaderDasNew,
  LargeButton,
  MainBody,
  OverlayLoader,
  PageTitle,
} from "components/core";
import { Ptag } from "components/core/fonts";
import backarrow from "assets/images/arrowBack.png";
import React, { useEffect, useMemo, useState } from "react";
import GradeSummaryAccordion from "./GradeSummaryAccordion";
import GradeSummaryDetail from "./GradeSummaryDetail";
import { colors } from "theme";
import http from "services/httpService";
import { useLocation, useNavigate } from "react-router";
import routes from "components/routes";
import { DisplayName } from "utlis/utils";
import { WidthLimiter } from "pages/PlanSetup/styles";
import { HomeWrapper } from "components/CdBalance/style";
import styled from "styled-components";

const GradeSummary = () => {
  const company_name = localStorage.getItem("company_name");
  const [isLoading, setLoader] = useState(false);
  const navigate = useNavigate();
  const grade_summary_details = JSON.parse(
    localStorage.getItem("eb_selected_values")
  );
  const eb_current_plan = localStorage.getItem("eb_current_plan");
  const [grades, setGrades] = useState([]);
  const [isFlat, setIsFlat] = useState(false);
  const [productIdName, setProductIdName] = useState([]);
  const { state } = useLocation();
  const [reusableData, setReusableData] = useState()
  useEffect(async () => {
    setLoader(true);
    var gradeArray;
    if (state) {
      try {
        const { data } = await http.get("business/userplans_data_selected/");
        gradeArray = data.userplans_data[state.useplanId].userplan_grades_data;
        data?.userplans_data[state.useplanId]?.flat_or_graded == "FLAT"
          ? setIsFlat(true)
          : setIsFlat(false);
      } catch (e) {
        console.log(e);
        return;
      }
    } else {
      const { data } = await http.get("business/userplans_data_selected/");

      gradeArray = data?.userplans_data[eb_current_plan]?.userplan_grades_data;
    }
    const userplan_id = state
      ? Object.values(state)[0]
      : localStorage.getItem("eb_current_plan");
    setGrades(gradeArray);
    const { data } = await http.get("/business/get_grade_setup_selectables/", {
      params: {
        userplan_id,
      },
    });
    setReusableData(data)
    const product_id_name = data.map((value, index) => {
      const id = value?.attribute_product_mapping_id;
      const name =
        value?.attribute_data?.attribute_ui_showables &&
        Object.keys(value?.attribute_data?.attribute_ui_showables)[0];
      return [id, name];
    });
    setProductIdName(product_id_name);
    setLoader(false);
  }, []);
  const redirectToUploadId = () => {
    const productType =
      grade_summary_details?.userplans_data[eb_current_plan]?.product_type
        .product_type_name;
    if (["health_insurance", "health_insurance_additional"].includes(productType)) {
      navigate(`/${routes.PRE_CORPORATE_BUFFER}`);
    } else {
      navigate(`/${routes.UNIVERSAL_COVERAGE_DOC}`);
    }
  };
  const productName = useMemo(() => {
    if (!grade_summary_details || !eb_current_plan) return;
    const name =
      grade_summary_details?.userplans_data[eb_current_plan]?.product_type
        .display_name ||
      grade_summary_details?.userplans_data[eb_current_plan]?.product_type
        .product_type_name;
    return DisplayName(name);
  }, [eb_current_plan, grade_summary_details]);
  const redirectToDashboard = () => {
    navigate(`/${routes.CARE_DASHBOARD}`);
  };

  return isLoading ? (
    <OverlayLoader />
  ) : (
    <>
      <SideNav>{state && <SideNavContent />}</SideNav>
      {state && <HeaderDasNew company_name={company_name} />}
      <HomeWrapper style={{ paddingTop: `${state ? "2rem" : ""}` }}>
        {!state && <PageTitle title={`Setup ${productName}`} />}
        <section
          style={{
            maxWidth: "900px",
          }}
        >
          <section
            style={{
              paddingTop: "2rem",
            }}
          >
            <div
              style={{
                display: "flex",
                marginBottom: "20px",
                alignItems: "center",
              }}
            >
              {state ? (
                <>
                  <img
                    style={{
                      marginRight: "10px",
                      height: "2.5rem",
                      width: "2.5rem",
                      cursor: `${state ? "pointer" : ""}`,
                    }}
                    onClick={() => redirectToDashboard()}
                    src={backarrow}
                  />
                  <Ptag
                    fontSize="20px"
                    fontWeight="bold"
                    color={colors.primaryColor}
                  >
                    Overview
                  </Ptag>
                </>
              ) : (
                <Ptag
                  fontSize="20px"
                  fontWeight="bold"
                  color={colors.primaryColor}
                >
                  Grade Setup Summary
                </Ptag>
              )}
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              {isFlat
                ? grades &&
                  grades.map((value, index) => (
                    <div key={index}>
                      <FlatSummay>
                        <GradeSummaryDetail
                          gradeData={value}
                          isFlat={isFlat}
                          productIdName={productIdName}
                          state={state}
                          reusables={reusableData}
                        />
                      </FlatSummay>
                    </div>
                  ))
                : grades &&
                  grades.map((value, index) => (
                    <div key={index}>
                      <GradeSummaryAccordion
                        title={`Grade ${index + 1}`}
                        defaultExpanded={index === 0}
                      >
                        <GradeSummaryDetail
                          gradeData={value}
                          productIdName={productIdName}
                          state={state}
                          reusables={reusableData}
                        />
                      </GradeSummaryAccordion>
                    </div>
                  ))}
            </div>
            {!state && (
              <LargeButton
                label="Confirm"
                marginTop="5rem"
                style={{
                  padding: "2rem",
                }}
                onClick={() => {
                  redirectToUploadId();
                }}
              />
            )}
          </section>
        </section>
      </HomeWrapper>
    </>
  );
};

export default GradeSummary;

const FlatSummay = styled.div`
  background-color: #f6f3ff;
  border-radius: 10px;
  max-width: 800px;
  padding: 32px 0 1px 32px;
`;
